import React, { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom';

import './Modal.css';

const modalRoot = document.getElementById('modal');

export const Modal = ({ 
  children,
  customClassName,
  title,
  closeButton,
  ModalBgCloseDisabled,
  ModalOpen,
  ModalOpenHandler
 }) => {

  const refContainer = useRef(document.createElement('div'));

  useEffect(() => {
    const modalContainer = refContainer.current;

    ModalOpen
      ? (modalRoot && modalRoot.firstChild == null) && (modalRoot && modalRoot.appendChild(modalContainer))
      : (modalRoot && modalRoot.firstChild !== null) && modalRoot.removeChild(modalContainer)

    // return () => (modalRoot && modalRoot.firstChild !== null) && modalRoot.removeChild(modalContainer)

  }, [ModalOpen]);

  const modalInterior = () => {
    return <div className={'Modal ' + (ModalOpen ? 'open ': '')}>
      <div 
        className="Modal__background"
        onClick={() => !ModalBgCloseDisabled && ModalOpenHandler(false)}
      />

      <div className={"Modal__content " + (customClassName ? customClassName : '')}>

        {(title || closeButton) && 
          <div className="Modal__title">

            {closeButton && 
              <button type="button" className="back" onClick={() => ModalOpenHandler(false)}>
              </button>
            }

            {title && <h1>{title}</h1>}
        </div>}

        {children}
      </div>
    </div>
  }

  return createPortal(modalInterior(), refContainer.current)
}